import { findIndex } from 'underscore';
import dropdownTemplateUrl from './dropdownTemplate.html';

/**
 * dropdownSelectedData - selected value
 * dropdownData - data which we are filtering
 * dropdownId - id of dropdown
 * dropdownRegexType - by default it compares from the beginning of the string
 *                   - possible value is look-ahead - seacrh from anywhere
 *
 */
(function () {
  angular.module('7Shop.Common')
    .directive('sDropdownInput', sDropdownInput);

  function sDropdownInput(
    $templateRequest,
    $compile,
    $rootScope,
    $document
  ) {
    return {
      scope: {
        sDropdownSelectedData: '=',
        sDropdownData: '=',
        sDropdownSelect: '=',
        sDropdownId: '@',
        sDropdownRegexType: '@',
        sDropdownPosition: '@',
        sDropdownDisable: '=?'
      },
      link: function (scope, elem) {
        var position = scope.sDropdownPosition ? scope.sDropdownPosition : 'down';
        var scrollStep = 34; // Default hardcoded value
        var dropdownVisible = false;
        var inputedValue = '';
        var focusTriggered = false;

        function setPosition() {
          var listContainer = elem.next();
          listContainer.css({
            top: position === 'down' ? elem.outerHeight() + 3 : -listContainer.outerHeight() - 3
          });
        }

        function initScrollStep() {
          var element;
          // if there is no data .dropdown-option
          // will be hidden
          if (!scope.sDropdownData.length) {
            return;
          }

          // we need to get height of single row,
          // each scroll action will move top/bottom for this value
          element = elem.parent().find('.dropdown-option');
          if (element && element[0].clientHeight) {
            scrollStep = element[0].clientHeight;
          }
        }

        $templateRequest(dropdownTemplateUrl).then(function (content) {
          var html = angular.element(content);
          var template = angular.element($compile(html)(scope));
          elem.after(template);
        });

        scope.selectedIndex = 0;

        /**
                 * Toggle dropdown
                 * @param {KeyboardEvent} e
                 */
        elem.on('focus click', function (e) {
          e.stopPropagation();

          if (e.type === 'focus') {
            focusTriggered = true;
            scope.openDropdown();
            return;
          }

          // after focus don't call click handlers
          if (focusTriggered) {
            focusTriggered = false;
            return;
          }

          if (dropdownVisible) {
            scope.closeDropdown();
          } else {
            scope.openDropdown();
          }
        });

        elem.on('keydown', function (e) {
          var keyInput;

          if (!dropdownVisible) {
            return false;
          }

          if (e.which === 40) {
            /**
                         * Key down
                         */
            if (scope.sDropdownData[scope.selectedIndex + 1]) {
              scope.selectedIndex += 1;
              scrollDown();
            }
            $rootScope.$evalAsync();
          } else if (e.which === 38) {
            /**
                         * Key up
                         */
            if (scope.sDropdownData[scope.selectedIndex - 1]) {
              scope.selectedIndex -= 1;
              scrollUp();
            }
            $rootScope.$evalAsync();
          } else if (e.which === 13) {
            /**
                         * On enter
                         */
            scope.selectData();
            scope.closeDropdown();
            // Trigger dygest manually
            $rootScope.$evalAsync();
          } else if (e.which === 27 || e.which === 9) {
            /**
                         * Escape or tab
                         */
            scope.closeDropdown();
          } else if (e.which === 111) {
            e.preventDefault();
            /**
                         * Divider character
                         */
            inputedValue += '/';
          } else if (e.which === 46) {
            e.preventDefault();
            /**
                         * Backspace
                         */
            inputedValue = inputedValue.slice(0, -1);
            filterInput();
          } else if (e.which === 8) {
            e.preventDefault();
            /**
                         * Delete
                         */
            inputedValue = '';
          } else {
            e.preventDefault();
            keyInput = String.fromCharCode(e.which);
            /**
                         * If value is alphabet character
                         */
            if (/[a-zA-Z]/mig.test(keyInput)) {
              inputedValue += keyInput;
              filterInput();
            }
          }

          return true;
        });

        scope.openDropdown = function () {
          dropdownVisible = true;
          $($document[0].getElementById(scope.sDropdownId))
            .removeClass('hidden')
            .addClass('visible');

          $document.on('click.dropdown', function (e) {
            if (e.target.className.indexOf(scope.sDropdownId) === -1) {
              scope.closeDropdown();
            }
          });
          initScrollStep();
          setSelectedIndex(scope.sDropdownSelectedData);
          setScrollPosition();
          setPosition();
          $rootScope.$evalAsync();
        };

        scope.selectData = function (index) {
          // Because bloody 0 is false
          var data = typeof index !== 'undefined' ? scope.sDropdownData[index] : scope.sDropdownData[scope.selectedIndex];
          scope.sDropdownSelect(data.value, data);
        };

        scope.closeDropdown = function () {
          dropdownVisible = false;
          $document.off('click.dropdown');
          $($document[0].getElementById(scope.sDropdownId))
            .removeClass('visible').addClass('hidden');
        };

        scope.$watch('sDropdownDisable', function () {
          elem.prop('disabled', scope.sDropdownDisable);
        });

        /**
                 * Run filter as long as there vare matching results, if there isn't
                 * run search again with last enered letter
                 */

        function filterInput() {
          var regEx = scope.sDropdownRegexType === 'look-ahead' ? new RegExp('.+(?=' + inputedValue + ')', 'mig')
            : new RegExp('^' + inputedValue, 'mig');
          var filteredValues = scope.sDropdownData.filter(function (value) {
            if (regEx.test(value.name)) {
              return value;
            }

            return false;
          });

          if (filteredValues.length) {
            setSelectedIndex(filteredValues[0].value);
            setScrollPosition();
          } else {
            inputedValue = inputedValue.slice(-1);
            filterInput();
          }
        }

        function setSelectedIndex(value) {
          if (!value) {
            scope.selectedIndex = 0;
          } else {
            scope.selectedIndex = findIndex(scope.sDropdownData, function (element) {
              return element.value === value;
            });
          }
        }

        function setScrollPosition() {
          $($document[0].getElementById(scope.sDropdownId))
            .scrollTop(scope.selectedIndex * scrollStep);
        }

        function scrollDown() {
          var currentPosition = $($document[0].getElementById(scope.sDropdownId))
            .scrollTop();
          $($document[0].getElementById(scope.sDropdownId))
            .scrollTop(currentPosition + scrollStep);
        }

        function scrollUp() {
          var currentPosition = $($document[0].getElementById(scope.sDropdownId))
            .scrollTop();
          $($document[0].getElementById(scope.sDropdownId))
            .scrollTop(currentPosition - scrollStep);
        }
      }
    };
  }
}());
